import { render, staticRenderFns } from "./MailsList.vue?vue&type=template&id=47eb15ea&scoped=true"
import script from "./MailsList.vue?vue&type=script&lang=js"
export * from "./MailsList.vue?vue&type=script&lang=js"
import style0 from "./MailsList.vue?vue&type=style&index=0&id=47eb15ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eb15ea",
  null
  
)

export default component.exports